import React from 'react';
import useFetchEvent from './hooks/useFetchEvent';
import { Skeleton } from 'antd';
import { isEmpty } from 'lodash';
import { StyledCard } from './stlyed';
import { AlertDescription } from './componentUtils';
import useSetManualAlertExport from './hooks/useSetManualAlertExport';
import { usePageTitle } from '@src/hooks';

function AlertInfo({ eventId }) {
  const { isFetching, data: info }: any = useFetchEvent({ eventId });

  useSetManualAlertExport(info);

  usePageTitle({ text: info ? `Alert - ${info.name}` : 'Alert...' });

  if (isFetching || isEmpty(info)) {
    return (
      <StyledCard variant="borderless">
        <Skeleton />
      </StyledCard>
    );
  }

  return <AlertDescription info={info} />;
}

export default AlertInfo;
